import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from "@angular/forms";
import { LunaCommonModule } from "../common/common.module";
import { TextTemplatesListComponent } from './text-templates-list/text-templates-list.component';
import { TextTemplateDetailComponent } from './text-template-detail/text-template-detail.component';
import { TextTemplatesService } from './text-templates.service';

import { Routes, RouterModule } from '@angular/router';
@NgModule({
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        LunaCommonModule
    ],
    providers:[TextTemplatesService],
    declarations: [TextTemplatesListComponent, TextTemplateDetailComponent]
})
export class TextTemplatesModule { }
